'use strict';

var React = require('react');

const MappedActionContext = /*#__PURE__*/React.createContext({});

exports.MappedActionContext = MappedActionContext;
